export enum ConfigTypeEnum {
    FEATURE_CONTROLS = 'Feature Controls',
    OTHER_CONTROLS = 'Other Controls',
}

export enum ConfigSubcategoriesEnum {
    WHATSAPP = 'whatsapp',
    TIMERS = 'timers',
}

export enum ConfigNameEnum {
    CONFIRMATION_PAGE_TIMER = 'confirmation_page_timer',
    MESSAGE_DELAY = 'message_delay',
    WHATSAPP_TIMER = 'whatsapp_timer',
}
